/**
 * "Equip to" labels for every card the user has Ctrl+clicked while
 * building an equip-source selection. The ring around the card itself
 * is a 3D card-child halo (syncTargetHaloMeshes, variant 'pending');
 * only this small text tag stays in DOM, positioned each frame by
 * GameBoard.updateEquipPendingOverlays.
 */
import { t } from '../../localization/t';

export default function EquipPendingOverlays({ pendingIds, registerRefs }) {
  const ids = Array.from(pendingIds || []);
  if (ids.length === 0) return null;

  return (
    <div aria-hidden="true">
      {ids.map((id) => (
        <Pair key={id} id={id} registerRefs={registerRefs} />
      ))}
    </div>
  );
}

function Pair({ id, registerRefs }) {
  const setLabel = (el) => registerRefs(id, 'label', el);
  return <div ref={setLabel} className="equip-pending-label">{t('Equip to')}</div>;
}
